import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IChecklistBeforeIndicator, IDefectType, IRoomType } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getChecklistBeforeIndicatorList = (data: IDynamicTableParams) => {
  return instance()
    .post<IChecklistBeforeIndicator[]>('/checkList/before/indicator/list', data)
    .then((response) => response.data);
};

export const getChecklistBeforeIndicatorListAll = () => {
  return instance()
    .get<IChecklistBeforeIndicator[]>('/checkList/before/indicator/listAllNotDeleted')
    .then((response) => response.data);
};

export const getChecklistBeforeIndicatorAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/checkList/before/indicator/availableColumns')
    .then((response) => response.data);
};

export const getChecklistBeforeIndicatorAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/checkList/before/indicator/availableGroupColumns')
    .then((response) => response.data);
};

export const loadChecklistBeforeIndicator = (indicatorId: number) => {
  return instance()
    .get<IChecklistBeforeIndicator>(`/checkList/before/indicator/${indicatorId}/load`)
    .then((response) => response.data);
};

export const createChecklistBeforeIndicator = (checklistBeforeIndicator: IChecklistBeforeIndicator) => {
  return instance()
    .post<IChecklistBeforeIndicator>(`/checkList/before/indicator/save`, checklistBeforeIndicator)
    .then((response) => response.data);
};

export const updateChecklistBeforeIndicator = (checklistBeforeIndicator: IChecklistBeforeIndicator) => {
  return instance()
    .post<IChecklistBeforeIndicator>(
      `/checkList/before/indicator/${checklistBeforeIndicator.indicatorId}/update`,
      checklistBeforeIndicator,
    )
    .then((response) => response.data);
};

export const archiveChecklistBeforeIndicator = (indicatorId: number) => {
  return instance()
    .post('/checkList/before/indicator/archive', { indicatorId })
    .then((response) => response.data);
};

export const recoverChecklistBeforeIndicator = (indicatorId: number) => {
  return instance()
    .post('/checkList/before/indicator/recover', { indicatorId })
    .then((response) => response.data);
};

// Dictionaries
export const getZones = () => {
  return instance()
    .post<string[]>('/checkList/before/indicator/zones')
    .then((response) => response.data);
};

export const getDefects = () => {
  return instance()
    .post<IDefectType[]>('/dictionary/defects', {})
    .then((response) => response.data);
};

export const getRoomTypes = () => {
  return instance()
    .get<IRoomType[]>('/app/roomType/listAllNotDeleted')
    .then((response) => response.data);
};
